import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './style.module.css';

type Props = {
    step2: boolean,
    step3: boolean,
}

const CheckoutHeader: React.FC<Props> = (props) => {
    return (
        <Box className={styles.mainContainer} >
            <Box className={styles.num_text_MainContainer}>
                <Box className={styles.num_text_Container}>
                    <div style={{
                        width: 32,
                        height: 32,
                        borderRadius: "100%",
                        backgroundColor: "#01B4BC",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }} >
                        <Box>
                            <Typography
                                className={styles.fontFamily}
                                style={{ color: "#fff", fontSize: 18, fontFamily: "Roboto", fontWeight: "400" }}
                            >
                                1
                            </Typography>
                        </Box>
                    </div>
                    <Typography style={{ color: "#282828", fontSize: 18, fontFamily: "Roboto", fontWeight: "400"  }}>
                        MY BAG
                    </Typography>
                </Box>
                <div className={styles.line}></div>
            </Box>

            <Box className={styles.num_text_MainContainer}>
                <Box className={styles.num_text_Container}>
                    <div style={{
                        width: 32,
                        height: 32,
                        borderRadius: "100%",
                        backgroundColor: props.step2 ? "#01B4BC" : "#e1e1e1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }} >
                        <Box>
                            <Typography
                                className={styles.fontFamily}
                                style={{ color: props.step2 ? "#fff" : "#A0A0A0", fontSize: 18, fontFamily: "Roboto", fontWeight: "400" }}
                            >
                                2
                            </Typography>
                        </Box>
                    </div>
                    <Typography style={{ color: props.step2 ? "#282828" : "#A0A0A0", fontSize: 18, fontFamily: "Roboto", fontWeight: "400" }}>
                        SHIPPING & BILLING
                    </Typography>
                </Box>
                <div className={styles.line}></div>
            </Box>

            <Box className={styles.num_text_MainContainer}>
                <Box className={styles.num_text_Container}>
                    <div style={{
                        width: 32,
                        height: 32,
                        borderRadius: "100%",
                        backgroundColor: props.step3 ? "#01B4BC" : "#e1e1e1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }} >
                        <Box>
                            <Typography
                                className={styles.fontFamily}
                                style={{ color: props.step3 ? "#fff" : "#A0A0A0", fontSize: 18, fontFamily: "Roboto", fontWeight: "400"}}
                            >
                                3
                            </Typography>
                        </Box>
                    </div>
                    <Typography style={{ color: props.step3 ? "#282828" : "#A0A0A0", fontSize: 18, fontFamily: "Roboto", fontWeight: "400" }}>
                        PAYMENT
                    </Typography>
                </Box>
                {/* <div className={styles.line}></div> */}
            </Box>
        </Box>
    )
}

export default CheckoutHeader